import React from 'react';
import '../Css/Report.css';
import Navbar from './Navbar';
import { Package, Truck, IdCard, ChartNoAxesCombined, FileChartColumnIncreasing } from 'lucide-react';

function openOrdersPage() {
  window.location.href = '/orderExcel';
}

function openDriversPage() {
  window.location.href = '/driver';
}

function openReportsPage() {
  window.location.href = '/reportId';
}

function openDailySummaryPage() {
  window.location.href = '/summary';
}

function openAccountsPage() {
  window.location.href = '/account';
}

function Report() {
  return (
    <>
      <Navbar />
      <div className="reports-hub">
        <h2 className="headS">Reports</h2>
        <div className="container">
          <div className="boxSy" onClick={openOrdersPage}>
            <Package className="reportIcon" />
            <h4>Orders</h4>
            <p>Order delivery and invoice reports.</p>
          </div>
          <div className="boxSy" onClick={openDriversPage}>
            <Truck className="reportIcon" />
            <h4>Drivers</h4>
            <p>Driver work hours and activity.</p>
          </div>
          <div className="boxSy" onClick={openReportsPage}>
            <IdCard className="reportIcon" />
            <h4>Report by ID</h4>
            <p>Open a driver report using Report ID.</p>
          </div>
          <div className="boxSy" onClick={openDailySummaryPage}>
            <ChartNoAxesCombined className="reportIcon" />
            <h4>Daily Summary</h4>
            <p>Day-wise driver and payment summary.</p>
          </div>
          <div className="boxSy" onClick={openAccountsPage}>
            <FileChartColumnIncreasing className="reportIcon" />
            <h4>Accounts</h4>
            <p>Payment mode and accounts report.</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Report;
